var icon = require('vue-svgicon')
icon.register({
  'ks-icon-job-type': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M45.19 69.86c1.7-.19 3.44-.35 5.21-.45A26.89 26.89 0 0 1 45.83 68zm61.25-22a5.81 5.81 0 0 0-5.5-3.88H83a27.05 27.05 0 0 1-.84 5.81h18.82l5.81 17.44H67.85a26.56 26.56 0 0 1-6.25 2.16c13.82.79 25.89 4.45 33.77 9.75a5.81 5.81 0 1 1 7.34 7.19 13.72 13.72 0 0 1 2.29 7.4v11.81a3.84 3.84 0 0 0 1.75.44h3.87a3.87 3.87 0 0 0 3.88-3.88v-31z"/><path pid="1" d="M56 22a21 21 0 1 1-21 21 21 21 0 0 1 21-21m0 52.5c23.21 0 42 9.4 42 21V106H14V95.5c0-11.6 18.79-21 42-21z"/>'
  }
})
